"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_CHOICE_KEY = exports.CHOICE_KEYS = exports.EnrollmentStatus = void 0;
exports.isChoiceKey = isChoiceKey;
exports.toChoiceKey = toChoiceKey;
/** 报名状态，与 `nup_enrollment.status` 一致。 */
var EnrollmentStatus;
(function (EnrollmentStatus) {
    /** 进行中，未选时可提交一次 4 选 1 */
    EnrollmentStatus[EnrollmentStatus["IN_PROGRESS"] = 0] = "IN_PROGRESS";
    /** 结算中（CAS，任务可重入） */
    EnrollmentStatus[EnrollmentStatus["SETTLING"] = 1] = "SETTLING";
    /** 已向 benefit 提交发奖 */
    EnrollmentStatus[EnrollmentStatus["AWARDED"] = 2] = "AWARDED";
    /** 无入金流水，可再报 */
    EnrollmentStatus[EnrollmentStatus["RE_ENROLLABLE"] = 3] = "RE_ENROLLABLE";
    /** 有入金但未达门槛 */
    EnrollmentStatus[EnrollmentStatus["BELOW_THRESHOLD"] = 4] = "BELOW_THRESHOLD";
})(EnrollmentStatus || (exports.EnrollmentStatus = EnrollmentStatus = {}));
exports.CHOICE_KEYS = [
    'nvidia',
    'btc',
    'voucher',
    'hsbc',
];
exports.DEFAULT_CHOICE_KEY = 'nvidia';
function isChoiceKey(value) {
    return exports.CHOICE_KEYS.includes(value);
}
/** 库内空值 / 非法值视为未选。 */
function toChoiceKey(value) {
    if (!value || !isChoiceKey(value)) {
        return null;
    }
    return value;
}
